import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { ImportRolesResponse } from "@/types";

async function importRoles(
  request: FormData
): Promise<ImportRolesResponse> {
  const response = await httpRequest.post<ImportRolesResponse>(
    "/positions/import",
    request,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
}

export function useImportRolesMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: importRoles,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["positions"] });
    },
  });
}